import Vue from 'vue';
import Vuex from 'vuex';
import Users from '@/services/Users.js';

Vue.use(Vuex);
export const store = new Vuex.Store({
	state: {
		user: {
			authenticated: false,
			admin: false,
			data: {
				userId: null,
				email: '',
				honorific: '',
				firstName: '',
				lastName: '',
				city: '',
				country: '',
				institution: '',
				displayName: '',
				abstractSubmitted: false,
				registered: false,
				vaccineSubmitted: false,
				position: ''
			}
		},
		cart: {
			items: [],
			total: 0
		}
	},
	getters: {
		user(state) {
			return state.user;
		},
		userDisplayName(state) {
			return `${state.user.data.firstName} ${state.user.data.lastName}`;
		},
		userCity(state) {
			return state.user.data.city;
		},
		userCountry(state) {
			return state.user.data.country;
		},
		userInstitution(state) {
			return state.user.data.institution;
		},
		userPosition(state) {
			return state.user.data.position;
		},
		userId(state) {
			return state.user.data.userId;
		},
		userEmail(state) {
			return state.user.data.email;
		},
		userHonorific(state) {
			return state.user.data.honorific;
		},
		userRegistered(state) {
			return state.user.data.registered;
		}
	},
	mutations: {
		// User Mutations
		SET_AUTHENTICATED(state, value) {
			state.user.authenticated = value;
		},
		SET_USER(state, data) {
			state.user.data = data;
		},
		SET_ADMIN(state, value) {
			state.user.admin = value;
		},
		SET_REGISTRATION(state, value) {
			state.user.data.registered = value;
		},
		SET_ABSTRACTSUBMITTED(state, value) {
			state.user.data.abstractSubmitted = value;
		},
		SET_VACCINATION(state, value) {
			state.user.data.vaccineSubmitted = value;
		},

		// Cart Mutations
		addItemToCart(state, i) {
			state.cart.items.push(i);
			state.cart.total += i.itemTotal;
		},
		removeItemFromCart(state, itemName) {
			var pos = state.cart.items.findIndex(
				item => item.name === itemName
			);
			if (pos > -1) {
				state.cart.total -= state.cart.items[pos].itemTotal;
				state.cart.items.splice(pos, 1);
			}
		},
		clearCart(state) {
			state.cart.items = [];
			state.cart.total = 0;
		}
	},
	actions: {
		// User Actions
		fetchUser({ commit }, user) {
			commit('SET_AUTHENTICATED', user !== null);
			if (user) {
				Users.getUser(user.uid).then(function(snapshot) {
					var userdata = snapshot.val();
					if (userdata) {
						commit('SET_USER', {
							userId: user.uid,
							email: user.email,
							honorific: userdata.honorific,
							firstName: userdata.firstName,
							lastName: userdata.lastName,
							displayName: userdata.firstName
								? userdata.firstName.concat(
										' ',
										userdata.lastName
											? userdata.lastName
											: ''
								  )
								: '',
							city: userdata.city,
							country: userdata.country,
							institution: userdata.institution,
							abstractSubmitted: userdata.abstract,
							registered: userdata.registered,
							position: userdata.position,
							vaccineSubmitted: userdata.vaccineSubmitted
						});
					}
				});
			} else {
				commit('SET_USER', {
					userId: null,
					email: null,
					firstName: '',
					lastName: '',
					displayName: '',
					abstractSubmitted: false,
					registered: false,
					position: '',
					vaccineSubmitted: false
				});
			}
		},
		updateUserRegistrationStatus({ commit }, userId) {
			if (userId != null || userId != '') {
				Users.getUser(userId).then(function(snapshot) {
					var userdata = snapshot.val();
					if (userdata) {
						commit('SET_REGISTRATION', userdata.registered);
					}
				});
			}
		},
		updateUserAbstractStatus({ commit }, userId) {
			if (userId != null || userId != '') {
				Users.getUser(userId).then(function(snapshot) {
					var userdata = snapshot.val();
					if (userdata) {
						commit('SET_ABSTRACTSUBMITTED', userdata.abstract);
					}
				});
			}
		},
		updateUserVaccinationStatus({ commit }, userId) {
			if (userId != null || userId != '') {
				Users.getUser(userId).then(function(snapshot) {
					var userdata = snapshot.val();
					if (userdata) {
						commit('SET_VACCINATION', userdata.vaccineSubmitted);
					}
				});
			}
		},
		setAdmin({ commit }, value = false) {
			commit('SET_ADMIN', value);
		},
		setAuthenticated({ commit }, value = false) {
			commit('SET_AUTHENTICATED', value);
		},

		// Cart Actions
		addItemToCart({ commit }, item) {
			commit('addItemToCart', item);
		},
		removeItemFromCart({ commit }, item) {
			commit('removeItemFromCart', item);
		},
		clearCart({ commit }) {
			commit('clearCart');
		}
	}
});
